import React from "react";
import { getAvatarInitials } from "../../utils";
import { Avatar } from "@common-ui/ui";

export const AssetImage = (props) => {
    const initials = props?.asset?.make || props?.asset?.name;
    const image_url = props?.asset?.image_url;

    if (image_url) {
        return (
            <img
                src={image_url}
                srcSet={image_url}
                alt={initials}
                loading="lazy"
                style={{ height: 40, objectFit: "contain" }} />
        );
    }
    return <Avatar variant="square" alt={initials} src={getAvatarInitials(initials)} />
}